<mat-form-field class="w-100" [subscriptSizing]="hideMatHint ? 'dynamic' : 'fixed'">
    <mat-label>{{ field.name }}</mat-label>
    <input [formControl]="fc" [name]="field.name" [placeholder]="field.name" matInput type="time" />
    @if (fc.value && !fc.disabled) {
        <button (click)="fc.setValue(null)" matSuffix mat-icon-button>
            <mat-icon fontSet="fas" fontIcon="fa-x"></mat-icon>
        </button>
    }
    <mat-error [control]="fc"></mat-error>
</mat-form-field>
